/***
 *
 *   BILLING
 *   Free users see upgrade page, paid users redirect to Stripe.
 *
 **********/

import { useContext, useEffect } from "react";
import { AuthContext, Alert, Animate, useNavigate, Card } from "components/lib";

export function Billing({ t }) {
  // context
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const isFree = authContext.user.plan === "free";

  // Prevent horizontal scroll on mount
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = 'auto';
      document.documentElement.style.overflowX = 'auto';
    };
  }, []);

  // Paid users: redirect to Stripe billing portal
  useEffect(() => {
    if (!isFree) {
      window.location.href = "https://billing.stripe.com/p/login/dRm5kE5VwdiReMC9AI93y00";
    }
  }, [isFree]);

  // Free tier view
  if (isFree) {
    return (
      <div className="min-h-screen w-full overflow-x-hidden" style={{ maxWidth: '100vw' }}>
        <div
          className="py-3 w-full box-border px-6 overflow-x-hidden"
          style={{
            width: window.innerWidth < 640 ? 'calc(100vw - 24px)' : 'calc(100vw - 256px - 24px)',
            maxWidth: window.innerWidth < 640 ? 'calc(100vw - 24px)' : 'calc(100vw - 256px - 24px)'
          }}
        >
          <Animate>
            <Card title={t("billing.free.title") || "Free Plan"}>
          <div className="space-y-6">
            <div className="flex justify-between items-center py-3 border-b border-white/10">
              <span className="text-white/60 poppins-light">{t("billing.free.current_plan") || "Current Plan"}</span>
              <span className="font-medium text-white poppins-regular">Free Tier</span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-white/10">
              <span className="text-white/60 poppins-light">{t("billing.free.price") || "Price"}</span>
              <span className="font-medium text-white poppins-regular">$0</span>
            </div>

            <div className="glass-card dark:glass-card-dark backdrop-blur-lg border border-white/10 rounded-lg p-6">
              <h3 className="font-semibold text-white/90 mb-4 poppins-medium">{t("billing.free.limits_title") || "Monthly Free Limits"}</h3>
              <div className="space-y-4 text-sm">
                <div className="flex justify-between items-center">
                  <span className="text-white/60 poppins-light">Maps API</span>
                  <span className="font-medium text-white poppins-regular">10,000 requests</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-white/60 poppins-light">Geocode API (forward, reverse)</span>
                  <span className="font-medium text-white poppins-regular">25,000 requests</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-white/60 poppins-light">All other APIs</span>
                  <span className="font-medium text-white poppins-regular">100,000 requests</span>
                </div>
              </div>
            </div>

            <Alert
              variant="info"
              title={t("billing.free.upgrade_title") || "Need more requests?"}
              description={t("billing.free.upgrade_description") || "Upgrade to our pay-as-you-go plan for unlimited requests."}
              button={{
                text: t("billing.free.upgrade_button") || "Upgrade Now",
                action: () => navigate("/billing/upgrade"),
              }}
            />
          </div>
        </Card>
      </Animate>
        </div>
      </div>
    );
  }

  // Show loading while redirecting to Stripe
  return null;
}
